import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { EventDataModel } from '../../models/events/event-data.model';
import { EventMappingModel } from '../../models/events/event-mapping.model';
export class CfEventService {
public mapping: EventMappingModel[] = [];
private weatherEvent = new Subject<EventDataModel>();
private chartEvent = new Subject<EventDataModel>();

  // Observable string streams
  weatherEvent$ = this.weatherEvent.asObservable();
  chartEvent$ = this.chartEvent.asObservable();
constructor() { }
/**
 * <p> This method is called by the component to emit data to others.</p>
 * @param {?} data <p> The data emitted with the source component name .</p>
 * @return {?}
 */
emitEvent(data: EventDataModel) {
    if (data['source'] === 'weather') { this.weatherEvent.next(data); } else {
      if (data['source'] === 'chart') { this.chartEvent.next(data); }
    }
  }
/**
 * @param {?} source
 * @return {?}
 */
getEvent(source: string) {
    if (source === 'weather') { return this.weatherEvent$; } else {
      if (source === 'chart') { return this.chartEvent$; } else { return null; }
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfEventService_tsickle_Closure_declarations() {
/** @type {?} */
CfEventService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfEventService.ctorParameters;
/** @type {?} */
CfEventService.prototype.mapping;
/** @type {?} */
CfEventService.prototype.weatherEvent;
/** @type {?} */
CfEventService.prototype.chartEvent;
/** @type {?} */
CfEventService.prototype.weatherEvent$;
/** @type {?} */
CfEventService.prototype.chartEvent$;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
